module.exports = __webpack_public_path__ + "img/other_pay_alipay.343558d1.svg";